// extracted by mini-css-extract-plugin
export var printerCard = "_b9-1";
export var printerCardConfigured = "_b9-2";
export var printerCardError = "_b9-3";
export var printerCardsContainer = "_b9-0";
export var printerIcon = "_b9-8";
export var printerIconConfigured = "_b9-5";
export var printerIconContainer = "_b9-4";
export var printerIconError = "_b9-6";
export var printerIconUnconfigured = "_b9-7";
export var workstationsTableCard = "_b9-9";